//@ts-check
import React from 'react';
import { Grid, Toolbar, Typography, makeStyles, createStyles } from '@material-ui/core';
import Icon from '../../core/Icon';
import Button from '../../core/Button';
import DropdownButton from '../../core/DropdownButton';
var useStyles = makeStyles(function () {
  return createStyles({
    root: {
      minHeight: 50
    }
  });
}, {
  name: 'ECFrameToolbar'
});
/** @param {import('./types').FrameToolbarProps} props */

var FrameToolbar = function FrameToolbar(_ref) {
  var title = _ref.title,
      icons = _ref.icons,
      button = _ref.button,
      moreOptions = _ref.moreOptions;
  var classes = useStyles({});
  return React.createElement(Toolbar, {
    className: classes.root
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between",
    alignItems: "center"
  }, React.createElement(React.Fragment, null, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, title)), React.createElement(Grid, {
    item: true
  }, icons && icons.map(function (icon) {
    return React.createElement(Icon, Object.assign({
      key: icon.type
    }, icon));
  })), React.createElement(Grid, {
    item: true
  }, button && React.createElement(Button, Object.assign({
    variant: "contained",
    color: "primary",
    "aria-label": typeof button.children === 'string' ? button.children : 'Submit'
  }, button)), moreOptions && moreOptions.length > 0 && React.createElement(DropdownButton, {
    options: moreOptions,
    type: "more",
    menuProps: {
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }
  })))));
};

export default FrameToolbar;